import { z } from 'zod';
export const ErrorCode = z.enum([
    'unauthorized',
    'forbidden',
    'not_found',
    'validation',
    'rate_limited',
    'gemini_key_invalid',
    'gemini_rate_limit',
    'gemini_unavailable',
    'internal',
]);
export const ErrorResponse = z.object({
    error: z.object({
        code: ErrorCode,
        message: z.string(),
        details: z.record(z.unknown()).optional(),
    }),
});
